export default __webpack_public_path__ + "static/media/products.933e9c4e.svg";